module.exports = __webpack_public_path__ + "img/domestic_hover.87d3e59.png";